import React, {useEffect, useState} from 'react';
import { slideWrapper } from '../components/slide';
import { Content } from '../components/content';
import styled from 'styled-components';
import { Text } from '../components/text';
import { useAnimationSteps } from '@disco/hooks';
import { TextLabel } from '../components/text-label';
import { SlideImage } from '../components/slide-image';

const DetailImage = styled.img`
  width: 100px;
  height: auto;
  margin-right: 20px;
`;

const TitleWrapper = styled.div<any>`
  opacity: ${(props) => (props.show ? 1 : 0)};
  display: flex;
  align-items: center;
`;

const TeslaLabel = styled.img`
  width: 200px;
  height: auto;
`;

const LabelWrapper = styled.div<any>`
  opacity: ${(props) => (props.show ? 1 : 0)};
  transition: opacity 0.3s;
`;

export const TeslaInformations = slideWrapper(
  ({ step, resources, getImg }) => {
    const { title, info1, info2, info3, info4, info5, info6, imageLabels } = step;

    const animationStep = useAnimationSteps(1);
    const [showRest, setShowRest] = useState(false)

    useEffect(() => {
      if (animationStep === 1 && !showRest) {
        setTimeout(() => {
          setShowRest(true)
        }, 1000)
      }
    }, [animationStep, showRest])

    return (
      <>
        <Content xNotCenter yNotCenter top={10} left={5}>
          <TitleWrapper show={animationStep > 0}>
            <DetailImage src={resources[imageLabels.detail]} />
            <Text big>{title}</Text>
          </TitleWrapper>
        </Content>
        <Content bottom={5} left={20}>
          <TeslaLabel src={resources[imageLabels.hypatia]} />
        </Content>
        <Content top={50} y={-200} left={50} x={-500}>
          <LabelWrapper show={showRest}>
            <TextLabel text={info1} xLength={60} yLength={100} right />
          </LabelWrapper>
        </Content>
        <Content top={50} y={-100} left={50} x={-660}>
          <LabelWrapper show={showRest}>
            <TextLabel text={info6} xLength={60} yLength={200} right />
          </LabelWrapper>
        </Content>
        <Content top={50} y={-270} left={50} x={450}>
          <LabelWrapper show={showRest}>
            <TextLabel text={info2} xLength={60} yLength={200} />
          </LabelWrapper>
        </Content>
        <Content top={50} y={-100} left={50} x={460}>
          <LabelWrapper show={showRest}>
            <TextLabel text={info3} xLength={60} yLength={300} />
          </LabelWrapper>
        </Content>
        <Content top={50} y={10} left={50} x={430}>
          <LabelWrapper show={showRest}>
            <TextLabel text={info4} xLength={60} yLength={200} />
          </LabelWrapper>
        </Content>
        <Content top={50} y={150} left={50} x={550}>
          <LabelWrapper show={showRest}>
            <TextLabel text={info5} xLength={60} yLength={300} />
          </LabelWrapper>
        </Content>

        <Content yNotCenter bottom={4} left={70}>
          <SlideImage src={getImg('tesla')} show />
        </Content>
      </>
    );
  },
  { backgroundSize: '100% 100%' }
);
